export const CREDIT_ADDRESS = "0x39f6c08d4c2f8b579166990dc3e3d862f14462c8";
export const USDT_ADDRESS = "0xD12882fAe52Daf4b8651Ad1D689d8bA1D48f1A9b";
export const DIAMOND_ADDRESS = "0x94636081d5F99D17AaEdc46a84D7c31E8F9D99f5";
export const COUPON_ADDRESS = "0x22DaB46930E34C2765Db10E7fe63C49325593438";